<template>
    <svg class="icon-quote fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.8 23.5"><g style="isolation:isolate"><path d="M44.4,34.3H51L44.4,57.8H36.3Zm18.1,0h6.6L62.5,57.8H54.4Z" transform="translate(-36.3 -34.3)"/></g></svg>
</template>
